import { useTenantStore } from '@features/tenant/store/tenant';
import {
  resolveSectionView,
  type ThemedSection,
} from '@features/tenant/sectionViewRegistry';

export const sectionComponent = (section: ThemedSection) => () =>
  resolveSectionView(section, useTenantStore().launcherTheme)();
